import type { Data } from '@repo/strapi'
import CkEditorCSRRenderer from '@/components/elementary/CkEditorRenderer/CkEditorCSRRenderer'
import { Container } from '@/components/elementary/Container'
import { BasicImage } from '@/components/page-builder/components/BasicImage'
import { cn } from '@/lib/styles'
import { getColorVariant } from '@/utils/colorMapping.tsx'

export function PricingBanner({
	component,
}: {
	readonly component: Data.Component<'shared.pricing-banner'>
}) {
	const { title, icon, backgroundColor } = component

	const bgClass = getColorVariant(backgroundColor?.color, 'bg', 'neutral-light-300')

	return (
		<Container className="gap-8 flex flex-col">
			<div
				className={cn(
					'flex gap-2.5 p-4 lg:py-7.5 lg:px-10 rounded-xl justify-center items-center',
					bgClass,
				)}
			>
				{icon?.media?.url && (
					<div className="relative size-9 shrink-0">
						<BasicImage component={icon} className="object-contain object-center" fill />
					</div>
				)}

				<div className={cn(icon?.media?.url && 'relative top-px')}>
					<CkEditorCSRRenderer htmlContent={title} variant="textOnly" />
				</div>
			</div>
		</Container>
	)
}

export default PricingBanner
